import { isInIframeInHubSpot } from './iframe';

// Local storage key for whether Copilot was previously open when the page loaded (i.e. open after a page reload)
// Values can be one of the following integers: 0 | 1 | 2
// 0 = closed | 1 = open | 2 = open expanded view
export const COPILOT_INITIALIZE_OPEN = 'copilot-initialize-open';
export function getIsCopilotDisabled(navLoaderOptions) {
  if (navLoaderOptions === false) {
    return true;
  }
  if (navLoaderOptions !== null && navLoaderOptions !== void 0 && navLoaderOptions.disableCopilotWhenEmbedded && isInIframeInHubSpot()) {
    return true;
  }
  return false;
}
export const COPILOT_SIDEBAR_SIDE = 'copilot-sidebar-side';
export const getShouldStartWithCopilotOpen = () => {
  try {
    const isCopilotInitiallyOpen = sessionStorage.getItem(COPILOT_INITIALIZE_OPEN);
    return isCopilotInitiallyOpen === '1' || isCopilotInitiallyOpen === '2';
  } catch (e) {
    return false;
  }
};